"use client";
import { useUserContext } from "../providers/UserContextProvider";
import {
  useProfilePictureContext,
  AWSImage,
  AvatarPlaceholder,
} from "../providers/ProfilePictureContextProvider";
import classNames from "@/utils/class-names";
import { useEffect } from "react";

export default function ProfilePicture({ className }: { className?: string }) {
  const { state: userState, status } = useUserContext();
  const { state, dispatch } = useProfilePictureContext();
  const src =
    state.imageUrl ??
    (state.id === "0"
      ? AvatarPlaceholder(state.firstName, state.lastName)
      : AWSImage(state.id, state.version));
  useEffect(() => {
    dispatch({ type: "init", ...userState.user });
  }, [userState.user]);
  if (status === "loading") {
    return "...loading";
  }
  return (
    <img
      src={src}
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = AvatarPlaceholder(
          state.firstName,
          state.lastName,
        );
        dispatch({ type: "hasPicture", hasPicture: false });
      }}
      alt="Profile picture"
      className={classNames("object-cover", className ?? "")}
    />
  );
}
